import { render, staticRenderFns } from "./FrmSelectResources.vue?vue&type=template&id=17c49060"
import script from "./FrmSelectResources.vue?vue&type=script&lang=js"
export * from "./FrmSelectResources.vue?vue&type=script&lang=js"
import style0 from "./FrmSelectResources.vue?vue&type=style&index=0&id=17c49060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports